var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-12",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('h1',{staticClass:"display-2 font-weight-bold mb-3"},[_vm._v("Welcome to SAIS Operation UI Portal")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }